<template>
	<span></span>
</template>

<script>
    export default {
		name: 'Toasts',
		watch: {
			toasts: {
				immediate: true,
				deep: true,
				handler(newValue, oldValue) {
					this.$bvToast.toast(
						this.toasts.content,
						{
							title: this.toasts.title,
							toaster: "b-toaster-top-right",
							autoHideDelay: this.toasts.autoHideDelay,
							appendToast: false,
							variant: this.toasts.variant
						}
					)
				}
			}
		},
		computed: {
			toasts: function () {
				return this.$store.state.Toasts
			}
		}
    }
</script>

<style scoped>
</style>